import { PropsWithChildren } from 'react';
import data from '../external-links.json';


type ExternalLinkProps = { linkKey: keyof typeof data } & Omit<React.AnchorHTMLAttributes<HTMLAnchorElement>, 'href'> & PropsWithChildren;

export default function ExternalLink({ linkKey, children, ...props }: ExternalLinkProps) {
    return (
        <a href={data[linkKey].url} title={data[linkKey].title} {...props}>
            {children}
        </a>
    );
}
